(function () {
  let currentInstance = null;

  class InfiniteScroll {
    constructor() {
      this.grid = document.getElementById('product-grid');
      this.paginationWrapper = document.querySelector('.pagination-wrapper');
      this.loading = false;
      this.finished = false;

      if (!this.grid || !this.paginationWrapper) return;

      // Huidige pagina uit de URL halen (standaard 1)
      const url = new URL(window.location.href);
      this.currentPage = parseInt(url.searchParams.get('page') || '1', 10);

      // Bijhouden welke producten al op de pagina staan (tegen dubbelen)
      this.seen = new Set();
      this.grid.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        this.seen.add(a.href.split('?')[0]);
      });

      // Pagineringsknoppen verbergen
      this.paginationWrapper.style.visibility = 'hidden';

      // Laad-indicator
      this.spinner = document.createElement('div');
      this.spinner.className = 'infinite-scroll-spinner';
      this.spinner.innerHTML = '<span></span>';
      this.spinner.style.cssText = 'text-align:center;padding:2rem 0;min-height:1px;';

      if (!document.getElementById('infinite-scroll-style')) {
        const style = document.createElement('style');
        style.id = 'infinite-scroll-style';
        style.textContent =
          '@keyframes is-spin{to{transform:rotate(360deg)}}' +
          '.infinite-scroll-spinner span{display:inline-block;width:2.4rem;height:2.4rem;border:3px solid rgba(0,0,0,.15);border-top-color:rgba(0,0,0,.6);border-radius:50%;animation:is-spin .8s linear infinite;visibility:hidden;}' +
          '.infinite-scroll-spinner.is-loading span{visibility:visible;}';
        document.head.appendChild(style);
      }

      this.paginationWrapper.parentNode.insertBefore(this.spinner, this.paginationWrapper);

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.loadNext();
        },
        { rootMargin: '800px' }
      );
      this.observer.observe(this.spinner);
    }

    buildNextUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('page', this.currentPage + 1);
      return url.toString();
    }

    async loadNext() {
      if (this.loading || this.finished) return;
      this.loading = true;
      this.spinner.classList.add('is-loading');

      try {
        const response = await fetch(this.buildNextUrl());
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid > li');
        let added = 0;

        newItems.forEach((item) => {
          const link = item.querySelector('a[href*="/products/"]');
          const key = link ? link.href.split('?')[0] : null;
          if (key && this.seen.has(key)) return;
          if (key) this.seen.add(key);
          this.grid.appendChild(item);
          added++;
        });

        if (added === 0) {
          // Geen nieuwe producten meer: klaar
          this.finished = true;
          this.destroy();
        } else {
          this.currentPage++;
        }
      } catch (e) {
        console.error('Infinite scroll fout:', e);
        this.finished = true;
        this.destroy();
        this.paginationWrapper.style.visibility = 'visible';
      } finally {
        this.loading = false;
        if (this.spinner) this.spinner.classList.remove('is-loading');
      }
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
      if (this.spinner) {
        this.spinner.remove();
        this.spinner = null;
      }
    }
  }

  function init() {
    if (currentInstance) currentInstance.destroy();
    currentInstance = new InfiniteScroll();
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();

    // Dawn vervangt de grid bij filteren of sorteren, dan opnieuw starten
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(() => {
        if (!currentInstance || !document.body.contains(currentInstance.grid)) {
          init();
        }
      }).observe(container, { childList: true, subtree: true });
    }
  });
})();